// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_md-5";
export var filledCircle = "_md-4";
export var historyEntry = "_md-3";
export var messageSideLeft = "_md-1";
export var messageSideRight = "_md-2";
export var orderTrackingCarouselWrapper = "_md-6";
export var orderTrackingInfoContainer = "_md-0";